import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { ShortcutActionName } from '../../core/constants';
import { IPcShortcutKeyManagerInjectable } from '../../core/interface';
import BaseShortcutKeyManagerInjectable from '../base/manager-injectable';

export default class PcShortcutKeyManagerInjectable
    extends BaseShortcutKeyManagerInjectable
    implements IPcShortcutKeyManagerInjectable {
    public getExtraBubbleKeyConfig() {
        // 桌面端本地编辑不屏蔽ctrl+s
        if (!ENV.IS_PC_LOCAL_EDIT) {
            const ctrl = (browser.isMac || browser.isIPad) ? 'command' : 'ctrl';
            return [
                {
                    key: `${ctrl}+s`,
                    actionKey: ShortcutActionName.BLOCKCTRL_S,
                },
            ];
        }
        return null;
    }
}
